/**
 * Validates the custom claims on a freshly signed-in Firebase user.
 *
 * dispatch-be mints custom tokens with top-level `{kind: 'ADMIN', realm:
 * <tenantName>}`; sphere-crm's verifyAdmin requires exactly that — and the
 * `realm` value is the ONLY tenant header it will accept. Anything else on this
 * Firebase project (an affiliate session, a driver app) must be signed out at
 * the door.
 */
export type ClaimsCheck =
  | { ok: true; realm: string }
  | { ok: false; reason: 'not_admin' | 'no_realm' };

export function validateClaims(
  claims: Record<string, unknown> | null | undefined,
): ClaimsCheck {
  if (!claims || claims['kind'] !== 'ADMIN') {
    return { ok: false, reason: 'not_admin' };
  }
  const realm = claims['realm'];
  if (typeof realm !== 'string' || realm.trim() === '') {
    return { ok: false, reason: 'no_realm' };
  }
  return { ok: true, realm };
}
